
/**
 * Based on https://github.com/kazupon/vue-i18n/blob/v8.x/src/components/interpolation.js
 * to support direct string definition instead of path definition.
 */

export default {
  name: 'Translated',
  functional: true,
  props: {
    tag: {
      type: [String, Boolean, Object],
      default: 'span'
    },
    locale: {
      type: String,
      default: null
    }
  },
  render (h, { data, parent, props, slots }) {
    const { $tr, $i18n } = parent
    if (!$i18n) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Cannot find VueI18n instance!')
      }
      return
    }

    const { locale } = props
    const params = slots()
    const input = (params.default || [{}])[0].text || ''
    if ('default' in params) delete params.default
    
    const children = $i18n._render(
      $tr.bind(parent)(input),
      locale,
      params
    )

    const tag = (!!props.tag && props.tag !== true) || props.tag === false ? props.tag : 'span'
    return tag ? h(tag, data, children) : children
  }
}
